<template>
  <b-modal v-model="vModel.ShowPromocodeDialog" ref="PromoCode" id="modal-center" class="modal-validation" size="md"
    no-close-on-backdrop="true" no-close-on-esc="true" centered hide-footer>
    <template v-slot:default>
      <div class="text-center">
        <h5>
          <font color="red">PROMO CODE</font>
        </h5>
      </div>
      <br>
      <!--use this for appycoupon-->
      <div class="row form-group">
        <div class="col-md-8 pad-r-0">
          <input type="text" class="form-control text-uppercase" id="promoCode" name="promoCode" autocomplete="off"
            v-model="vModel.SearchedPromocode" data-vv-as="Promo Code" v-validate="'required'" :class="{
							input: true,
							'is-danger': errors.has(
								'promoCode'
							)
						}" />
          <div v-show="errors.has('promoCode')" style="color:red">
            {{ errors.first("promoCode") }}
          </div>
        </div>
        <div class="col-md-2 pad-l-0">
          <input type="button" class="btn btn-appy" value="apply" @click="onSearchPromocode" />
        </div>
      </div>
      <!--end use this for appycoupon-->
      <div class="row" v-if="vModel.PromocodeDetailList!=null && vModel.PromocodeDetailList.length>0">
        <div class="col-md-12">
          <label for><b>or select Promo Code from the list</b></label>
        </div>
      </div>
      <div class="pc_wrap">
        <div class="pro_code_dialog" v-for="item in vModel.PromocodeDetailList" v-bind:key="item.PromotionCodeId"
          @click="onPromocodeSelect(item.PromotionCodeId)">
          <div class="row">
            <div class="col-md-6">
              <div class="wb_left">
                <h5>{{item.PromoCode}}</h5>
                <span style="font-size:12px;">
                  <i>{{ item.TotalPromocodesUsed }}/{{item.TotalPromocodesAvailable}}<span style="margin-left:1rem">Expires on: {{ item.ValidityDateToString }}</span></i>                    
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="wb_right" v-if="!item.IsFreeServiceCharge">
                <div class="_price_dialog">
                  <span>RM</span>
                  {{ item.PromotionDiscount.toFixed(2) }}
                </div>
                <div class="doyf_dialog">Discount on your fee</div>
              </div>
              <div class="wb_right" v-if="item.IsFreeServiceCharge">
                <div class="_price_dialog">FREE</div>
                <div class="doyf_dialog">Service Fee</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
  import CommonService from "../services/common";
  export default {
    name: "PromocodeDialog",
    props: ["vModel"],
    methods: {
      onSearchPromocode: function () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.onProgress = true;

            this.$http
              .post("v2/transaction/validate/promocode", {
                RecipientId: this.vModel.RecipientDetail.Id,
                PaymentNetworkId: this.vModel.PayoutModeId == 101 || this.vModel.PayoutModeId == 102 ? 3 : 1,
                PaymentModeId: this.vModel.PayoutModeId,
                PromoCode: this.vModel.SearchedPromocode,
              })
              .then(
                (response) => {
                  this.vModel.UsedPromocodeDetail = response.body;
                  this.vModel.IsMtaPromotionCodeSelected = true;
                  this.vModel.PromotionDiscount = this.vModel.UsedPromocodeDetail.PromotionDiscount.toFixed(2);
                  this.vModel.ShowPromocodeDialog = false;
                  this.onProgress = false;
                },
                (error) => {
                  this.onProgress = false;
                }
              );
          }
        });
      },
      onPromocodeSelect: function (promotionCodeId) {
        this.vModel.UsedPromocodeDetail = this.vModel.PromocodeDetailList.filter((s) => {
          return s.PromotionCodeId == promotionCodeId;
        })[0];
        this.vModel.IsMtaPromotionCodeSelected = true;
        this.vModel.PromotionDiscount = this.vModel.UsedPromocodeDetail.PromotionDiscount.toFixed(2);
        this.vModel.ShowPromocodeDialog = false;

      }
    }
  };
</script>